<template>
  <div>
    <!-- 到货抽查 抽查项目选择：-->
    <el-dialog :title="$t('message.spotCheckItemSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1680px" center>
      <div class="content">
        <div class="row">
          <div class="search">
            <!--    交易号：  -->
            {{ $t('message.transactionNumber') }}：
            <div class="item"> <el-input v-model="purchase_no"></el-input></div>
            <!-- 物流号： -->
            {{ $t('message.logisticsNumber') }}：
            <div class="item"> <el-input v-model="express_no"></el-input></div>
            <!-- 查询 -->
            <el-button type="primary" @click="spotDetailOptionType">{{ $t('message.inquire') }}</el-button>
          </div>
          <!-- 加入任务 -->
          <el-button type="primary" @click="addToTask">{{ $t('message.addToTask') }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">
              {{ $t("message.choose") }}
            </li>
            <!-- 订单号 -->
            <li class="flex2">{{ $t('message.orderNumber') }}</li>
            <!-- 番号 -->
            <li>{{ $t('message.mash') }}</li>
            <!-- 店铺信息 -->
            <li>{{ $t('message.storeInformation') }}</li>
            <!-- 照片 -->
            <li>{{ $t('message.pic') }}</li>
            <!-- 应检数 -->
            <li>{{ $t('message.numberToBeChecked') }}</li>
            <!-- 业务编辑属性 -->
            <li class="flex2">{{ $t('message.businessEditAttributes') }}</li>
            <!-- 当前数据 -->
            <li class="flex2">{{ $t('message.currentData') }}</li>
            <!-- 附加服务 -->
            <li class="flex2">{{ $t('message.additionalServices') }}</li>
            <!-- 客户商品备注 -->
            <li class="flex2">{{ $t('message.customerProductRemarks') }}</li>
            <!-- 业务备注     -->
            <li class="flex2">{{ $t('message.serviceRemarks') }}</li>
            <!-- 采购备注 -->
            <li class="flex2">{{ $t('message.purchasingNotes') }}</li>
            <!-- 配货备注 -->
            <li class="flex2">{{ $t('message.distributionRemarks') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- 选择 -->
            <li class="flex05">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex2">
              <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                {{ item.order_sn }}
              </router-link>
            </li>
            <!-- 番号 -->
            <li>{{ item.sorting }}</li>
            <!-- 店铺信息 -->
            <li>
              <div class="template">
                <p>{{ item.shop_name }}</p>
                <p style="color: #15ad3c">{{ item.from_platform }} ({{ (item.service_rate * 100).toFixed(1) }}%)</p>
                <p>{{ item.shop_id }}</p>
              </div>
            </li>
            <!-- 照片 -->
            <li>
              <el-image style="width: 60px; height: 60px" :src="item.pic" :preview-src-list="[item.pic]">
              </el-image>
            </li>
            <!-- 应检数 -->
            <li>{{ item.inspect_should_num }}</li>
            <!-- 业务编辑属性 -->
            <li class="flex2">
              <div class="attribute">
                <el-tooltip placement="bottom" style="height:100px">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      @click="copy(itemDetail.value)">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 当前数据 -->
            <li class="flex2">
              <div class="template">
                <p>
                  数量：{{ item.confirm_num }}
                </p>
                <p>单价：{{ item.confirm_price }}</p>
                <p>国内运费：{{ item.confirm_freight }}</p>
                <p>小计：{{ ((item.confirm_num * item.confirm_price) + (item.confirm_freight - 0)).toFixed(2) }}</p>
              </div>
            </li>
            <!-- 附加服务 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom" style="max-height: 100px">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 客户商品备注 -->
            <li class="flex2">{{ item.client_remark }}</li>
            <!-- 业务备注     -->
            <li class="flex2">{{ item.y_remark }}</li>
            <!-- 采购备注 -->
            <li class="flex2">{{ item.g_remark }}</li>
            <!-- 配货备注 -->
            <li class="flex2">{{ item.p_remark }}</li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    taskType: { type: [Number, String] },
  },
  data() {
    return {
      purchase_no: '3615288770575996716',
      express_no: '',
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    // 查询
    spotDetailOptionType() {
      let datas = {
        purchase_no: this.purchase_no,
        express_no: this.express_no,
        type: this.taskType
      }
      this.$api.spotCheckApi.spotDetailOptionType2(datas).then(res => {
        res.data.forEach(item => {
          item.checked = false
          item.num = ''
        })
        this.tableData = res.data
      })
    },
    //加入任务
    addToTask() {
      let list = []
      this.tableData.forEach(item => {
        if (item.checked) {
          list.push(item)
        }
      })
      if (list == false) return this.$message.error('请选择抽查项目')
      this.$parent.addSpotDetail(list)
      this.dialogVisible = false
    }
  },
};
</script>
<style lang='scss' scoped>
.content {

  min-height: 200px;

  .row {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;

    .search {
      display: flex;
      line-height: 40px;

      .item {
        margin-right: 20px;
      }
    }
  }

  .table {
    border: 1px solid #edeff4;
    max-height: 600px;
    overflow-y: auto;

    ol {
      display: flex;
      height: 50px;
      position: sticky;
      top: 0;
      left: 0;
    }

    ul {
      display: flex;
      padding: 0px 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }
  }


}
</style>